export const newData = [
  {
    name: "",
    shtrix: "",
    kolOv: "",
    ostatka: "",
    foto: "",
  },
];
